import { useContext } from 'react';

import { ScreenTypeContext } from '@/utils/ScreenTypeContext/ScreenTypeContext';

export function useScreenType() {
  const context = useContext(ScreenTypeContext);
  if (!context) {
    throw new Error('useScreenType must be used within a ScreenTypeProvider');
  }
  return context;
}
